module.exports = __webpack_public_path__ + "media/images/favicons/icon-16x16-fef501481b9ba9c28936e50f8a015d12.png";